import React from 'react';
import { IColumn } from '@fluentui/react';
import { Link } from 'react-router-dom';

export interface IStatToolOpenProcess {
  processType: string;
  openProcesses: number;
  processTypeIds: number[];
}

interface IStatToolOpenProcessesData {
  annualFinancialStatementCount?: number;
  annualFinancialStatementProcessTypeIds?: number[];
  directTaxCount?: number;
  directTaxProcessTypeIds?: number[];
  otherTaxCount?: number;
  otherTaxProcessTypeIds?: number[];
  otherProcessesCount?: number;
  otherProcessesProcessTypeIds?: number[];
}

export const getStatToolOpenProcesses = (
  openProcesses?: IStatToolOpenProcessesData,
): IStatToolOpenProcess[] => [
  {
    processType: 'Annual Financial Statements',
    openProcesses: openProcesses?.annualFinancialStatementCount ?? 0,
    processTypeIds: openProcesses?.annualFinancialStatementProcessTypeIds ?? [],
  },
  {
    processType: 'Direct Tax',
    openProcesses: openProcesses?.directTaxCount ?? 0,
    processTypeIds: openProcesses?.directTaxProcessTypeIds ?? [],
  },
  {
    processType: 'Other Tax',
    openProcesses: openProcesses?.otherTaxCount ?? 0,
    processTypeIds: openProcesses?.otherTaxProcessTypeIds ?? [],
  },
  {
    processType: 'Other Processes',
    openProcesses: openProcesses?.otherProcessesCount ?? 0,
    processTypeIds: openProcesses?.otherProcessesProcessTypeIds ?? [],
  },
];

const getStatToolOpenProcessesColumns = (
  companyCode?: string,
  canViewProcesses?: boolean,
): IColumn[] => {
  // Create base query parameters that are constant for all records
  const baseQueryParams = new URLSearchParams();
  if (companyCode) {
    baseQueryParams.append('companyCodes', companyCode);
  }
  baseQueryParams.append('processStatuses', 'ACTIVE');

  // Build a Process page URL filtered to this row's process type(s)
  const createFilterUrl = (item: IStatToolOpenProcess): string => {
    const queryParams = new URLSearchParams(baseQueryParams);
    item.processTypeIds.forEach((processTypeId) => {
      queryParams.append('processTypeIds', processTypeId.toString());
    });

    return `/processes?${queryParams.toString()}`;
  };

  return [
    {
      key: 'processType',
      name: 'Process Type',
      fieldName: 'processType',
      minWidth: 250,
      maxWidth: 400,
      isResizable: true,
    },
    {
      key: 'openProcesses',
      name: 'Open Processes',
      fieldName: 'openProcesses',
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
      onRender: (item: IStatToolOpenProcess) => {
        if (!item.openProcesses || item.processTypeIds.length === 0) {
          return <span style={{ color: 'inherit' }}>{item.openProcesses ?? 0}</span>;
        }

        const url = createFilterUrl(item);

        return canViewProcesses ? (
          <Link to={url}>{item.openProcesses}</Link>
        ) : (
          <span style={{ color: 'inherit' }}>{item.openProcesses}</span>
        );
      },
    },
  ];
};

export default getStatToolOpenProcessesColumns;
